import { SmartObjectImage as SmartObjectImageBase } from '@max/tiptap-extensions'
import { VueNodeViewRenderer } from '@tiptap/vue-2'
import SmartObjectImageNodeView from '@/components/editor/SmartObjectImageNodeView'

export const SmartObjectImage = SmartObjectImageBase.extend({
    addNodeView () {
        return VueNodeViewRenderer(SmartObjectImageNodeView)
    },
})
